// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"a153fbd1","731":"0ab74963","905":"75c4dd35"}[chunkId] + ".chunk.js";
};